import { useEffect } from "react";
import { SITE } from "@/lib/site";

type SeoOptions = {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  type?: string;
  noindex?: boolean;
};

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function usePageSeo({ title, description, keywords, path = "/", type = "website", noindex = false }: SeoOptions) {
  useEffect(() => {
    const fullTitle = title.includes(SITE.name) ? title : `${title} - ${SITE.name}`;
    const url = `${SITE.domain}${path}`;
    const kw = keywords ?? SITE.keywords;

    document.title = fullTitle;
    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", kw);
    upsertMeta("name", "robots", noindex ? "noindex,follow" : "index,follow,max-image-preview:large");
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:site_name", SITE.name);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertLink("canonical", url);
  }, [title, description, keywords, path, type, noindex]);
}